import { render } from "./TopNavigation.vue?vue&type=template&id=7aa30d0a"
import script from "./TopNavigation.vue?vue&type=script&lang=js"
export * from "./TopNavigation.vue?vue&type=script&lang=js"
script.render = render

export default script